import React from 'react';
import { Page } from '../../page/page';
import { CodeEditor } from '../../code-editor/code-editor';
import { HintModal } from '../../modal/hint-modal';

import './example-C.css';

const svgLogo = "<svg class='svg-logo' version='1.1' id='Layer_1' x='0px' y='0px' viewBox='0 0 437 120'>\n  <g>\n    <path d='M26.3,18.9v68h-8.8v-68H26.3z'/>\n    <path d='M42.4,51.2c0-5.1-0.2-9.1-0.4-13.2h7.8l0.5,8h0.2c2.4-4.6,8.1-9.1,16.1-9.1c6.7,0,17.2,4,17.2,20.8v29.1H75V58.7 c0-7.9-3-14.5-11.3-14.5c-5.8,0-10.4,4.1-12,9.1c-0.4,1.1-0.6,2.7-0.6,4.1v29.4h-8.8V51.2z'/>\n    <path d='M98.6,19.8c4.5-0.9,10.9-1.5,16.9-1.5c9.3,0,15.5,1.8,19.7,5.6c3.4,3,5.3,7.6,5.3,12.9c0,8.9-5.7,14.9-12.8,17.3v0.2 c5.2,1.8,8.3,6.7,10,13.8c2.2,9.5,3.8,16,5.2,18.7h-9.1c-1.1-2-2.6-7.8-4.5-16.3c-2-9.3-5.7-12.9-13.6-13.2h-8.3v29.5h-8.8V19.8z	M107.4,50.7h9c9.4,0,15.4-5.1,15.4-12.9c0-8.8-6.4-12.7-15.6-12.7c-4.3,0-7.2,0.4-8.7,0.8V50.7z'/>\n    <path d='M153.5,15.2h8.8v30.5h0.2c1.5-2.5,3.7-4.7,6.4-6.3c2.6-1.5,5.7-2.5,9.1-2.5c6.6,0,17,4,17,20.8v29.1h-8.8V58.8 c0-7.9-3-14.5-11.3-14.5c-5.8,0-10.3,4.1-12,8.9c-0.5,1.2-0.6,2.6-0.6,4.2v29.5h-8.8V15.2z'/>\n    <path d='M211.4,38.1l10.7,28.8c1.1,3.2,2.3,7.1,3.1,10h0.2c0.9-2.9,1.9-6.6,3.1-10.2l9.7-28.6h9.4l-13.4,34.8 c-6.3,16.8-10.7,25.3-16.7,30.6c-4.4,3.8-8.7,5.3-10.9,5.7l-2.2-7.4c2.2-0.7,5.1-2.1,7.8-4.3c2.4-1.9,5.4-5.4,7.4-9.9 c0.4-0.9,0.7-1.6,0.7-2.1c0-0.5-0.1-1.2-0.6-2.3l-18-45H211.4z'/>\n    <path d='M266.4,24v14h12.8v6.7h-12.8v26.3c0,6.1,1.8,9.5,6.7,9.5c2.3,0,4-0.3,5.1-0.6l0.4,6.7c-1.7,0.7-4.5,1.2-7.9,1.2 c-4.1,0-7.5-1.3-9.6-3.8c-2.4-2.7-3.4-7-3.4-12.7V44.8h-7.6v-6.7h7.6V26.3L266.4,24z'/>\n    <path d='M289.1,15.2h8.8v30.5h0.2c1.5-2.5,3.7-4.7,6.4-6.3c2.6-1.5,5.7-2.5,9.1-2.5c6.6,0,17,4,17,20.8v29.1h-8.8V58.8 c0-7.9-3-14.5-11.3-14.5c-5.8,0-10.3,4.1-12,8.9c-0.5,1.2-0.6,2.6-0.6,4.2v29.5h-8.8V15.2z'/>\n    <path d='M345.1,51.2c0-5.1-0.2-9.1-0.4-13.2h7.7l0.5,7.9h0.2c2.7-4.6,7.3-9,15.4-9c6.6,0,11.7,4,13.8,9.8h0.2 c1.6-2.8,3.5-4.9,5.5-6.4c3-2.2,6.1-3.4,10.7-3.4c6.5,0,16.1,4.2,16.1,21.2v28.7h-8.7V59.3c0-9.5-3.5-15-10.6-15 c-5.1,0-9,3.7-10.6,8c-0.4,1.3-0.7,2.9-0.7,4.5v30.2h-8.7V57.6c0-7.8-3.4-13.4-10.1-13.4c-5.5,0-9.6,4.4-11.1,8.9 c-0.4,1.3-0.7,2.9-0.7,4.4v29.4h-8.7V51.2z'/>\n  </g>\n</svg>";
const svgCSS = ".svg-logo {\n  width: 80%;\n  stroke: #F25B21;\n  fill: rgba(242, 91, 33, 0);\n}";
const pathCSS = ".svg-logo path {\n  /* ... */\n}";

const css =  {
  isEditable: true,
  initial: `${svgCSS}\n\n${pathCSS}`,
}

const html = {
  isEditable: true,
  initial: `${svgLogo}`
}

const js = {
  isEditable: false,
  initial: "",
}

export const ExampleC = (props) => {
  return <Page html={html} css={css} js={js}>
    <div className="example">
      <h1 className="title">Challenge 3: SVG Animation</h1>
      <div className="instructions">Use SVG properties <a target="_blank" href="https://css-tricks.com/almanac/properties/s/stroke-dasharray/"><code>stroke-dasharray</code></a>, <a target="_blank" href="https://css-tricks.com/almanac/properties/s/stroke-dashoffset/"><code>stroke-dashoffset</code></a>, and <a target="_blank" href="https://css-tricks.com/almanac/properties/f/fill/"><code>fill</code></a> to draw the InRhythm logo.
			<br/>(full tutorial <a href="https://www.youtube.com/watch?v=y0Ic8QcvyK8">here</a>)
			</div>
      

<svg className="svg-logo" version="1.1" id="Layer_1" x="0px" y="0px"
	 viewBox="0 0 437 120">
<g>
	<path d="M26.3,18.9v68h-8.8v-68H26.3z"/>
	<path d="M42.4,51.2c0-5.1-0.2-9.1-0.4-13.2h7.8l0.5,8h0.2c2.4-4.6,8.1-9.1,16.1-9.1c6.7,0,17.2,4,17.2,20.8v29.1H75V58.7
		c0-7.9-3-14.5-11.3-14.5c-5.8,0-10.4,4.1-12,9.1c-0.4,1.1-0.6,2.7-0.6,4.1v29.4h-8.8V51.2z"/>
	<path d="M98.6,19.8c4.5-0.9,10.9-1.5,16.9-1.5c9.3,0,15.5,1.8,19.7,5.6c3.4,3,5.3,7.6,5.3,12.9c0,8.9-5.7,14.9-12.8,17.3v0.2
		c5.2,1.8,8.3,6.7,10,13.8c2.2,9.5,3.8,16,5.2,18.7h-9.1c-1.1-2-2.6-7.8-4.5-16.3c-2-9.3-5.7-12.9-13.6-13.2h-8.3v29.5h-8.8V19.8z
		 M107.4,50.7h9c9.4,0,15.4-5.1,15.4-12.9c0-8.8-6.4-12.7-15.6-12.7c-4.3,0-7.2,0.4-8.7,0.8V50.7z"/>
	<path d="M153.5,15.2h8.8v30.5h0.2c1.5-2.5,3.7-4.7,6.4-6.3c2.6-1.5,5.7-2.5,9.1-2.5c6.6,0,17,4,17,20.8v29.1h-8.8V58.8
		c0-7.9-3-14.5-11.3-14.5c-5.8,0-10.3,4.1-12,8.9c-0.5,1.2-0.6,2.6-0.6,4.2v29.5h-8.8V15.2z"/>
	<path d="M211.4,38.1l10.7,28.8c1.1,3.2,2.3,7.1,3.1,10h0.2c0.9-2.9,1.9-6.6,3.1-10.2l9.7-28.6h9.4l-13.4,34.8
		c-6.3,16.8-10.7,25.3-16.7,30.6c-4.4,3.8-8.7,5.3-10.9,5.7l-2.2-7.4c2.2-0.7,5.1-2.1,7.8-4.3c2.4-1.9,5.4-5.4,7.4-9.9
		c0.4-0.9,0.7-1.6,0.7-2.1c0-0.5-0.1-1.2-0.6-2.3l-18-45H211.4z"/>
	<path d="M266.4,24v14h12.8v6.7h-12.8v26.3c0,6.1,1.8,9.5,6.7,9.5c2.3,0,4-0.3,5.1-0.6l0.4,6.7c-1.7,0.7-4.5,1.2-7.9,1.2
		c-4.1,0-7.5-1.3-9.6-3.8c-2.4-2.7-3.4-7-3.4-12.7V44.8h-7.6v-6.7h7.6V26.3L266.4,24z"/>
	<path d="M289.1,15.2h8.8v30.5h0.2c1.5-2.5,3.7-4.7,6.4-6.3c2.6-1.5,5.7-2.5,9.1-2.5c6.6,0,17,4,17,20.8v29.1h-8.8V58.8
		c0-7.9-3-14.5-11.3-14.5c-5.8,0-10.3,4.1-12,8.9c-0.5,1.2-0.6,2.6-0.6,4.2v29.5h-8.8V15.2z"/>
	<path d="M345.1,51.2c0-5.1-0.2-9.1-0.4-13.2h7.7l0.5,7.9h0.2c2.7-4.6,7.3-9,15.4-9c6.6,0,11.7,4,13.8,9.8h0.2
		c1.6-2.8,3.5-4.9,5.5-6.4c3-2.2,6.1-3.4,10.7-3.4c6.5,0,16.1,4.2,16.1,21.2v28.7h-8.7V59.3c0-9.5-3.5-15-10.6-15
		c-5.1,0-9,3.7-10.6,8c-0.4,1.3-0.7,2.9-0.7,4.5v30.2h-8.7V57.6c0-7.8-3.4-13.4-10.1-13.4c-5.5,0-9.6,4.4-11.1,8.9
		c-0.4,1.3-0.7,2.9-0.7,4.4v29.4h-8.7V51.2z"/>
</g>
</svg>


      <HintModal>
			 	Start by testing different values for stroke-dasharray on the path elements:
        <pre>
          <div className="code">
            { `.svg-logo path {`} <br/>
            { `   stroke-dasharray: 1...10000 */`}<br/>
            { `}`}
          </div>
        </pre>
        In our keyframes animation, animate the stroke-dashoffset from the value found above down to zero:
        <pre>
          <div className="code">
            { `@keyframes drawText {`}<br/>
            { `    0% { stroke-dashoffset:  ?? } `} <br/>
						{ `    100% { stroke-dashoffset:  0 } `} <br/>
            { `}`}<br/>
          </div>
        </pre>
      </HintModal>
    </div>
    <CodeEditor html={html} css={css} js={js} defaultTab={'css'} />
  </Page>
}
